import { render, staticRenderFns } from "./disableMsgrButton.vue?vue&type=template&id=746ff750&"
import script from "./disableMsgrButton.vue?vue&type=script&lang=ts&"
export * from "./disableMsgrButton.vue?vue&type=script&lang=ts&"
import style0 from "./disableMsgrButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports